<template>
  <div class="rating-summary">
    <div class="rating-summary__left">
      <div class="rating-star-wrap">
        <i
          v-for="n in calculateStarsAmount(ratingAverage)[0]"
          :key="`f-${n}`"
          class="icon-star-filled rating-star-wrap__icon"
        />
        <i
          v-for="n in calculateStarsAmount(ratingAverage)[1]"
          :key="`h-${n}`"
          class="icon-star-half-filled rating-star-wrap__icon"
        >
          <span class="path1" />
          <span class="path2" />
        </i>
        <i
          v-for="n in calculateStarsAmount(ratingAverage)[2]"
          :key="`e-${n}`"
          class="icon-star-filled rating-star-wrap__icon rating-star-wrap__icon--empty"
        />
      </div>
      <div class="rating-avg-wrap">
        <span class="rating-avg-wrap__number">{{ ratingAverage }}</span>
        <span class="rating-avg-wrap__caption">/</span>
        <span class="rating-avg-wrap__caption">5</span>
      </div>
    </div>
    <div class="rating-count">
      <span>{{ formatNumber(ratingAmount) }}</span>
      <span>則評價</span>
    </div>
  </div>
</template>

<script>
import { formatNumber, calculateStarsAmount } from '@/utils/rating'

export default {
  name: 'RatingSummary',
  props: {
    ratingAverage: {
      type: Number,
      required: true,
      default: 0
    },
    ratingAmount: {
      type: Number,
      required: true,
      default: 0
    }
  },
  methods: {
    calculateStarsAmount,
    formatNumber
  }
}
</script>

<style scoped lang="scss">

.rating-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: pxTorem(24px);

  &__left {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

@media screen and (max-width: $mobileWidth) {
  .rating-summary {
    margin-top: 20px;
    margin-bottom: 0;

    &__left {
      margin-left: 12px;
    }
  }
}

.rating-star-wrap {
  display: flex;
  align-items: center;
  gap: 8px;

  &__icon {
    font-size: pxTorem(24px);
    color: $color-rating;
    display: flex;

    &--empty {
      color: $color-background-primary;
    }
  }
}

@media screen and (max-width: $mobileWidth) {
  .rating-star-wrap {
    gap: 2px;

    &__icon {
      font-size: 16px;
    }
  }
}

.rating-avg-wrap {
  display: flex;
  align-items: baseline;
  gap: pxTorem(6px);
  margin-left: pxTorem(12px);

  &__number {
    font-size: pxTorem(25px);
    font-weight: 600;
  }

  &__caption {
    font-size: pxTorem(20px);
    color: $color-caption;

    &--divider {
      margin-left: pxTorem(8px);
      margin-right: pxTorem(8px);
    }
  }
}

@media screen and (max-width: $mobileWidth) {
  .rating-avg-wrap {
    &__number {
      font-size: 18px;
    }

    &__caption {
      font-size: 13px;

      &--divider {
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
}

.rating-count {
  display: flex;
  font-size: pxTorem(18px);
  font-weight: 600;
  color: $color-caption;
}

@media screen and (max-width: $mobileWidth) {
  .rating-count {
    font-size: 13px;
  }
}
</style>
